import { Typography } from '@/components';
import { TextStyles } from '@/constants';
import styled from 'styled-components';

export const LeftHeaderWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  columnGap: theme.spacing[4],
}));

export const SectionTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 6'],
})(({ theme }) => ({
  color: theme.colors.darkBlue,
}));

export const SectionId = styled(Typography).attrs({
  variant: TextStyles['Body Text Small'],
})(({ theme }) => ({
  color: theme.colors.highEmphasisBlack,
  wordBreak: 'break-all',
  textAlign: 'right',
}));

export const SectionIconWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.colors.darkBlue,
  ['> svg, img']: {
    width: 20,
    height: 20,
  },
}));

export const HeaderWrapper = styled.div<{
  gutterBottom?: boolean;
}>(({ theme, gutterBottom }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingBottom: gutterBottom ? theme.spacing[8] : 0,
  borderBottom: gutterBottom ? `1px solid ${theme.colors.surface05}` : 0,
}));
